import axios from 'axios';
import apiUrl from '../constants';

export function newAWB(data, token){
    let input;
    let ShippingIDs = [];
      data.map(shippingId => {
        ShippingIDs.push(shippingId.shippingid);
      });
      input = ({
        shippingid: ShippingIDs.toString()
      });
     return axios({
        method: 'post',
        url: apiUrl.api_url + 'stdrecreasonmapping',
        data: input,
        headers: {
          'Authorization': 'Bearer ' + token
        }
      })
}

export function RecReasonData(token){
    return axios({
        method: 'post',
        url: apiUrl.api_url + 'recReasons',
        data: {},
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });
}



// WEBPACK FOOTER //
// ./src/services/getDataCall.js